import React from 'react'
import Utils from '../../util/Utils'

function PendingPayTable({PendingPayData , erpData , setOpenPendingPay}) {
  return (
      <div>
               <h4 style={{color : "#2C358A" , fontSize : "32px" , fontWeight: '600'}}>Pending Pay</h4>
           <h6 className='ml-2'><a onClick={()=>setOpenPendingPay(false)}>Dashboard </a>{'>'} Pending Pay</h6> 
          <table className='penActionsDashTable' style={{ width: "100%", borderCollapse: "collapse" }}  >
        
            <thead>
                <th style={{ width: "15%" }}>Booking Id</th>
                <th style={{ width: "10%" }}>ERP Job Id</th>
                <th style={{ width: "15%" }}>HBL/MBL</th>
                <th style={{ width: "10%" }}>Invoice Number</th>
                <th style={{ width: "10%" }}>Invoice Date</th>
                <th style={{ width: "10%" }}>Ageing</th>
            </thead>
            </table>
             <div style={{maxHeight : "200px" , overflowY : 'scroll' ,overflowX: 'scroll' ,minWidth : "100%" }}>  
             <table style={{ width: "100%", borderCollapse: "collapse" }}>        
             <tbody >
                         {
                  PendingPayData?.map((r,i) => 
                   { let erpobj =  erpData?.filter((x)=>x.bookingNum === r._id )[0]
                    return  <tr>
                        <td style={{ width: "15%" }}>
                           {r._id} 
                        </td>
                        <td style={{ width: "10%" }}>{erpobj?.x     }</td>
                        <td style={{ width: "15%" }}>{erpobj?.HOUSE_NO}</td>
                        <td style={{ width: "10%" }}>{erpobj?.DOCUMENT_NO}</td>
                        <td style={{ width: "10%" }}>{erpobj?.DOCUMENT_DATE}</td>
                        <td style={{ width: "10%" }}>{ erpobj ? Utils.docAgeing(erpobj ) : ''}</td>
                        </tr>
                   }
                   )
                }
             </tbody>
             </table>
             </div>
           </div>  

  )
}

export default PendingPayTable
